import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';


@Component({
  selector: 'group-wrapper',
  imports:[],
  template: `
    <div class="mt-2">
      <p class="font-bold">{{ props.label }}</p>
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class GroupWrapper extends FieldWrapper {
}